import React from "react";

import {MuiIcon, MuiIconExternalProps} from "../MuiIcon";

export const PIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\uf865'}</MuiIcon>
        );
    })